












































import { Component, Mixins } from "vue-property-decorator";

// Data/Enums
import { ShopItemsLayout } from "@/data/shop/enums";
import { BrandConfigKeys } from "@/data/constants";
import { PriceDisplayTypes } from "@/data/enums/prices";

// Types
import { IShopListItem } from "@/models/shop";
import { IProductPrice, IMigrationRelatedObject } from "@/models/products";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";

@Component({
  components: {
    "shop-products-list": () =>
      import("@/components/app/global/baskets/basket/shop/shopProductsList.vue")
  }
})
export default class MigrationsListModal extends Mixins(CProdInjectorMixin) {
  public migrations: IMigrationRelatedObject[] = [];

  public isReloading = false;
  public isLoading = true;
  public isProcessing = false;
  public requestError = false;

  public limit = 4;
  public offset = 0;
  public hasMore = false;
  public isLoadingMore = false;

  public get itemsLayout() {
    return this.migrations.length < 3
      ? ShopItemsLayout.HORIZONTAL
      : ShopItemsLayout.VERTICAL;
  }

  public created() {
    this.loadMore();
  }

  public updateMigrations(results) {
    this.offset = this.offset + this.limit;
    this.hasMore = results.total > this.offset;
    this.migrations = this.$_.concat(
      this.migrations,
      this.mapItems(this.$_.get(results, "data", []))
    );
  }

  public openProductDetailModal({ item }: { item: IShopListItem }) {
    return this.$cProdMethods.openMigrationProductDetailModal(item);
  }

  public mapItems(items) {
    return this.$_.map(items, item => {
      const asLMFP = // asLMFP = as Lowest Monthly From Price
        this.$store.getters["brand/config"][
          BrandConfigKeys.PRICE_DISPLAY_TYPE
        ] === PriceDisplayTypes.MONTHLY_FROM;

      item.prices = this.$_.orderBy(
        this.$_.map(item.prices, price => ({
          ...this.$_.pick(price as IProductPrice, [
            "billing_cycle_months",
            "monthly_price_from_discounted_formatted",
            "monthly_price_from_formatted",
            "price",
            "price_discounted",
            "price_discounted_formatted",
            "price_formatted"
          ]),
          ...this.$store.getters["data/catalogue/productTermSavings"](price)
        })),
        [
          term => {
            return asLMFP
              ? this.$_.isNil(term.price_discounted)
                ? (term.price as number)
                : (term.price_discounted as number) /
                  (term.billing_cycle_months as number)
              : term.billing_cycle_months;
          }
        ],
        ["asc"]
      );

      return {
        ...this.$_.pick(item, ["id", "object_id", "image"]),
        product: item,
        type: "product",
        name: item.name_translated || item.name,
        description: item.description_translated || item.description,
        label: this.$t("_action.review_changes"),
        route: {
          query: {
            migration_id: item.id
          }
        }
      } as IMigrationRelatedObject;
    });
  }

  public async loadMore() {
    this.isLoadingMore = true;

    try {
      this.updateMigrations(
        await this.$cProdMethods.getMigrationProducts(this.limit, this.offset)
      );
      this.requestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    } finally {
      this.isLoadingMore = false;
      this.isLoading = false;
    }
  }

  public migrate(productData) {
    this.$emit("migrateProduct", productData._product.id);
  }

  public guardFunctionalities = [];

  public get contentIsAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }
}
